module.exports = __webpack_public_path__ + "img/sum.ce0aa568.svg";